import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { can } from "../utils/permissions";

/** `perm`: permissão (ou lista: basta uma) necessária para abrir a página. */
export default function ProtectedRoute({ children, perm, superAdmin = false }) {
  const { user, ready } = useAuth();

  if (!ready) return <div style={{ padding: 24 }}>Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;

  if (superAdmin && !user.isSuperAdmin) return <div style={{ padding: 24 }}>Sem permissão.</div>;

  if (perm && !can(user, perm)) return <div style={{ padding: 24 }}>Sem permissão.</div>;
  return children;
}
